//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Model from '@/models/login'
import mobileModel from '@/models/mobile'
import PwdBox from './PwdBox'
import Menu from '@/router/menu'
import { mapGetters, mapActions } from 'vuex'
export default {
    components: {
        PwdBox
    },
    data(){
        return{
            menuList:Menu,
            isCollapse: this.$isMobile
        }
    },
    computed:{
        ...mapGetters('user',{
            user:'getUser'
        })
    },
    methods:{
        ...mapActions('user',{
            setUserBalance:'setUserBalanceAction'
        }),
        async getUserMoney() {
            let { data } = await mobileModel.getUserMoney(this.user.userName);
            if(data.success) {
                this.setUserBalance(data.list);
            }
        },
        async loginOut(){
            let { data } = await Model.loginOut();
            if(data.success){
                sessionStorage.removeItem('user');
                sessionStorage.removeItem('access_token');
                this.$router.push('/login')
            }
        },
        menuSelect() {
            if(this.$isMobile) this.isCollapse = true;
        },
        editPwd() {
            this.$refs.resetBox.visible = !this.$refs.resetBox.visible;
        },
        linkToRecharge() {
            let h = this.$createElement,
                host = window.location.origin,
                tel = this.user.userName,
                token = sessionStorage.getItem('access_token'),
                isPayment = this.$isMobile && (this.$isWx || this.$isZfb)
            if(isPayment) {
                this.$router.push(`/mobile/recharge/${token}/${tel}`)
            }else {
                if(this.$isMobile) {
                    this.$router.push('/code')
                }else {
                    this.$msgbox({
                        title: '提示',
                        showConfirmButton: false,
                        message: h('div', { style: 'text-align: center' }, [
                            h('img', { attrs: { src: `http://qr.liantu.com/api.php?text=${host}/mobile/recharge/${token}/${tel}` } }, null),
                            h('p', { style: 'font-size: 20px' }, '请使用微信或支付宝扫码进行充值'),
                            h('p', { style: 'font-size: 20px' }, '充值完成后请刷新后台界面更新余额')
                        ], null)
                    })
                }
            }
        }
    },
    created() {
        this.getUserMoney()
    }
}



// WEBPACK FOOTER //
// ./src/pages/index/view.vue